/* live-bump-1780569785921 */
document.documentElement.classList.remove("no-js");

const money = (cents) => {
  const currency = window.Shopify?.currency?.active || "INR";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);
  } catch {
    return `Rs. ${(cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
  }
};

const normalize = (value) => String(value || "").toLowerCase().replace(/\s+/g, "").replace(/[--]/g, "-");

const cleanSizeLabel = (value) => String(value || "")
  .replace(/\b(?:18\s*-\s*20|18\s*to\s*20|3\s*-\s*5|3\s*to\s*5)\s*days?\b/gi, "")
  .replace(/\s*[,/|]\s*$/g, "")
  .replace(/^[,/|]\s*/g, "")
  .replace(/\s{2,}/g, " ")
  .trim();

const displaySizeLabel = (value) => cleanSizeLabel(value).replace(/^UK\s*/i, "UK ");

const displayShippingLabel = (value) => String(value || "")
  .replace(/18\s*-\s*20/gi, "18-21")
  .toLowerCase();

const shippingMatches = (variantValue, selectedValue) => {
  const variant = normalize(variantValue);
  const selected = normalize(selectedValue);
  if (!variant || !selected) return true;
  if (selected.includes("3-5") || selected.includes("3to5")) return variant.includes("3") && variant.includes("5");
  if (selected.includes("18-20") || selected.includes("18to20") || selected.includes("18-21") || selected.includes("18to21")) return variant.includes("18") && (variant.includes("20") || variant.includes("21"));
  if (selected.includes("next")) return variant.includes("next");
  return variant === selected;
};

const setWishlistState = () => {
  let saved = [];
  try {
    saved = JSON.parse(localStorage.getItem("ffWishlist") || "[]");
  } catch {
    saved = [];
  }
  document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
    button.classList.toggle("is-active", saved.includes(button.getAttribute("data-product-id")));
    button.setAttribute("aria-pressed", saved.includes(button.getAttribute("data-product-id")) ? "true" : "false");
  });
};

const initWheelPassthrough = () => {
  const rails = ".ff-home [data-ff-rail], .ff-home .ff-product-strip, .ff-home .ff-category-strip, .ff-home .ff-hero-carousel, .ff-home .ff-designer-carousel, .ff-product-grid, .ff-brand-grid";
  document.querySelectorAll(rails).forEach((rail) => {
    if (rail.dataset.ffWheelReady === "true") return;
    rail.dataset.ffWheelReady = "true";
    rail.addEventListener("wheel", (event) => {
      if (!event.shiftKey) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      if (rail.scrollWidth <= rail.clientWidth) return;
      event.preventDefault();
      rail.scrollLeft += event.deltaY;
    }, { passive: false });
  });
};

const fixHomeRailScroll = () => {
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const sectionWidth = isMobile ? "calc(100vw - 10px)" : "calc(100vw - 96px)";
  const sectionMarginLeft = isMobile ? "calc(50% - 50vw + 10px)" : "48px";
  const sectionMarginRight = isMobile ? "0" : "48px";
  const sections = document.querySelectorAll(".ff-home-categories, .ff-luxe-home .ff-home-rail");
  sections.forEach((section) => {
    const isProductSection = section.classList.contains("ff-home-rail");
    const sectionOverflow = isMobile && !isProductSection ? "visible" : "hidden";
    section.style.setProperty("width", sectionWidth, "important");
    section.style.setProperty("max-width", sectionWidth, "important");
    section.style.setProperty("min-width", sectionWidth, "important");
    section.style.setProperty("margin-left", sectionMarginLeft, "important");
    section.style.setProperty("margin-right", sectionMarginRight, "important");
    section.style.setProperty("padding-left", "0", "important");
    section.style.setProperty("padding-right", "0", "important");
    section.style.setProperty("overflow", sectionOverflow, "important");
    section.style.setProperty("box-sizing", "border-box", "important");

    const heading = section.querySelector(".ff-section-heading--split");
    if (heading) {
      heading.style.setProperty("padding-left", "0", "important");
      heading.style.setProperty("padding-right", "0", "important");
      heading.style.setProperty("margin-left", "0", "important");
      heading.style.setProperty("margin-right", "0", "important");
    }

    const rail = section.querySelector("[data-ff-rail]");
    if (!rail) return;
    rail.style.setProperty("width", "100%", "important");
    rail.style.setProperty("max-width", "100%", "important");
    rail.style.setProperty("min-width", "0", "important");
    rail.style.setProperty("display", "flex", "important");
    rail.style.setProperty("flex-wrap", "nowrap", "important");
    rail.style.setProperty("overflow-x", "auto", "important");
    rail.style.setProperty("overflow-y", "hidden", "important");
    rail.style.setProperty("margin-left", "0", "important");
    rail.style.setProperty("margin-right", "0", "important");
    rail.style.setProperty("padding-left", "0", "important");
    rail.style.setProperty("padding-right", "0", "important");
    if (isMobile) {
      const railGap = isProductSection ? "12px" : "8px";
      rail.style.setProperty("gap", railGap, "important");
      rail.style.setProperty("column-gap", railGap, "important");
      if (isProductSection) {
        rail.querySelectorAll(":scope > .ff-product-card").forEach((card) => {
          card.style.setProperty("flex", "0 0 72vw", "important");
          card.style.setProperty("width", "72vw", "important");
          card.style.setProperty("min-width", "72vw", "important");
          card.style.setProperty("max-width", "72vw", "important");
        });
      }
    }
    rail.style.setProperty("-webkit-overflow-scrolling", "touch", "important");
    rail.style.setProperty("touch-action", "pan-x pan-y", "important");
    rail.style.setProperty("scroll-snap-type", "x proximity", "important");
  });
};

const escapeHtml = (value) => String(value || "")
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;");

const formatStorefrontPrice = (value) => {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount) || amount <= 0) return "";
  return `Rs. ${Math.round(amount).toLocaleString("en-IN")}`;
};

const splitRankingTerms = (value) => String(value || "")
  .split(/[,|/]+/)
  .map((term) => term.trim().toLowerCase())
  .filter(Boolean);

const handleize = (value) => String(value || "")
  .toLowerCase()
  .replace(/&/g, "and")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "");

const productTokens = (product) => {
  const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
  return [
    ...tags,
    product.vendor,
    product.product_type,
    product.title
  ].join(" ").toLowerCase();
};

const BRAND_ALIASES = {
  adidas: ["adidas"],
  nike: ["nike"],
  jordan: ["jordan", "air jordan"],
  "new-balance": ["new balance"],
  yeezy: ["yeezy"],
  seiko: ["seiko"],
  casio: ["casio"],
  swatch: ["swatch"],
  dior: ["dior"],
  ysl: ["ysl", "yves saint laurent"],
  coach: ["coach"],
  "michael-kors": ["michael kors"],
  "marc-jacobs": ["marc jacobs"],
  stanley: ["stanley"],
  "pop-mart": ["pop mart"]
};

const CATEGORY_ALIASES = {
  sale: ["sale", "discount", "offer", "offers", "drop", "drops"],
  sneakers: ["sneakers", "sneaker", "shoes", "shoe", "footwear", "casual footwear", "daily footwear", "performance footwear"],
  apparel: ["apparel", "clothing", "tops", "t-shirts", "t shirt", "shirts", "hoodie", "sweatshirt", "shorts", "trousers", "pants", "jackets", "denim", "tracksuits"],
  watches: ["watches", "watch", "quartz watches", "analog watches", "mechanical watches", "watch accessories"],
  accessories: ["accessories", "accessory", "wallets", "jewelry", "watch accessories"],
  bags: ["bags", "bag", "handbags", "handbag"],
  perfumes: ["perfumes", "perfume", "fragrance", "beauty"]
};

const detectAliasKeys = (value, aliases) => {
  const haystack = String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ");
  return Object.entries(aliases)
    .filter(([, terms]) => terms.some((term) => haystack.includes(term.toLowerCase())))
    .map(([key]) => key);
};

const categoryTermsForKeys = (keys = []) => {
  const terms = [];
  keys.forEach((key) => {
    (CATEGORY_ALIASES[key] || []).forEach((term) => terms.push(term));
  });
  return [...new Set(terms)];
};

const intentFromContext = (...values) => {
  const text = values.filter(Boolean).join(" ");
  const brandKeys = detectAliasKeys(text, BRAND_ALIASES);
  const categoryKeys = detectAliasKeys(text, CATEGORY_ALIASES).filter((key) => key !== "sale");
  const saleMode = detectAliasKeys(text, { sale: CATEGORY_ALIASES.sale }).includes("sale");
  return {
    brandKeys,
    brandTerms: [...new Set(brandKeys.flatMap((key) => BRAND_ALIASES[key] || []))],
    categoryKeys,
    categoryTerms: categoryTermsForKeys(categoryKeys),
    saleMode
  };
};

const productMatchesBrand = (product, brandTerms = []) => {
  const vendorText = String(product.vendor || "").toLowerCase();
  const titleText = String(product.title || "").toLowerCase();
  return brandTerms.some((term) => {
    const normalized = String(term || "").toLowerCase();
    return vendorText === normalized || vendorText.includes(normalized) || titleText.includes(normalized);
  });
};

const productMatchesCategory = (product, categoryKeys = []) => {
  if (!categoryKeys.length) return true;
  const tokens = productTokens(product);
  return categoryKeys.some((key) => (CATEGORY_ALIASES[key] || []).some((term) => tokens.includes(term)));
};

const productMatchesSale = (product) => {
  const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
  const compare = Number(product.variants?.[0]?.compare_at_price || product.compare_at_price || 0);
  const price = Number(product.variants?.[0]?.price || product.price || 0);
  if (compare > price && price > 0) return true;
  return [...tags, product.title, product.product_type].join(" ").toLowerCase().includes("sale")
    || [...tags, product.title, product.product_type].join(" ").toLowerCase().includes("discount");
};

const popularityScore = (product) => Number(product.score || product.popularity_score || product.popularityScore || 0);

const productPopularityScore = (product, index = 0) => {
  const directScore = popularityScore(product);
  if (directScore) return directScore * 1000;
  const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
  const taggedScore = tags.reduce((score, tag) => {
    const match = String(tag || "").match(/(?:popularity|popular|score)[\s:_-]*(\d+)/i);
    return match ? Math.max(score, Number(match[1]) || 0) : score;
  }, 0);
  const variant = product.variants?.[0] || {};
  const price = Number(variant.price || product.price || 0);
  const compare = Number(variant.compare_at_price || product.compare_at_price || 0);
  const discountScore = compare > price && price > 0 ? Math.min(80, ((compare - price) / compare) * 100) : 0;
  const recencyScore = product.created_at ? Math.max(0, 30 - ((Date.now() - Date.parse(product.created_at)) / 86400000)) : 0;
  const collectionOrderScore = Math.max(0, 250 - index) / 10;
  return taggedScore * 5 + discountScore + recencyScore + collectionOrderScore;
};

const rankProducts = (products) => [...products].sort((a, b) => productPopularityScore(b) - productPopularityScore(a));

let popularityDataPromise;
const productByHandleCache = new Map();
const popularityAssetUrl = () => {
  const assetNode = Array.from(document.scripts)
    .find((script) => script.src && script.src.includes("/assets/farfetch-template.js"))
    || Array.from(document.querySelectorAll('link[href*="/assets/farfetch-template.css"]'))[0];
  const assetUrl = assetNode?.src || assetNode?.href || "";
  if (assetUrl.includes("/assets/")) return assetUrl.replace(/\/assets\/[^/?#]+.*$/, "/assets/luxe-popularity-scores.json");
  return "/cdn/shop/t/7/assets/luxe-popularity-scores.json";
};

const loadPopularityProducts = async () => {
  if (!popularityDataPromise) {
    popularityDataPromise = fetch(popularityAssetUrl(), { headers: { Accept: "application/json" } })
      .then((response) => {
        if (!response.ok) throw new Error("Could not load popularity scores");
        return response.json();
      })
      .then((data) => Object.values(data.products || {}));
  }
  return popularityDataPromise;
};

const fetchCollectionProducts = async (handle, limit = 250, page = 1) => {
  const safeHandle = handle || "all";
  const response = await fetch(
    `/collections/${encodeURIComponent(safeHandle)}/products.json?limit=${Math.min(limit, 250)}&page=${Math.max(page, 1)}`,
    { headers: { Accept: "application/json" } }
  );
  if (!response.ok) throw new Error(`Could not load ${safeHandle}`);
  const data = await response.json();
  return data.products || [];
};

const fetchAllCollectionProducts = async (handle, maxPages = 12) => {
  const pages = [];
  for (let page = 1; page <= maxPages; page += 1) {
    const products = await fetchCollectionProducts(handle, 250, page);
    if (!products.length) break;
    pages.push(...products);
    if (products.length < 250) break;
  }
  const seen = new Set();
  return pages.filter((product) => {
    const key = product.handle || product.id;
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const withPopularityScores = (products, popularityProducts = []) => {
  const scoreByHandle = new Map(popularityProducts.map((product) => [product.handle, product]));
  return products.map((product) => {
    const matched = scoreByHandle.get(product.handle);
    return matched ? { ...product, ...matched, variants: product.variants || matched.variants || [] } : product;
  });
};

const productImageUrl = (product) => {
  const image = product?.featured_image
    || product?.image
    || product?.images?.[0]
    || product?.media?.[0]?.preview_image
    || product?.media?.[0];
  if (!image) return "";
  if (typeof image === "string") return image;
  return image.src || image.url || image.preview_image?.src || "";
};

const hasProductImage = (product) => Boolean(productImageUrl(product));

const currentProductHandle = () => location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || "";

const fetchProductByHandle = async (handle) => {
  if (!handle) return null;
  if (productByHandleCache.has(handle)) return productByHandleCache.get(handle);
  const promise = fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: "application/json" } })
    .then((response) => (response.ok ? response.json() : null))
    .catch(() => null);
  productByHandleCache.set(handle, promise);
  return promise;
};

const applyDefaultBestSellingSort = () => {
  /* Collection pages are populated in-place from tag/category matches and popularity score. */
};

const specificTermsForHandle = (handle, title = "") => {
  const genericTerms = new Set([
    "all", "collections", "collection", "products", "product", "designer", "designers",
    "top", "tops", "top-50", "50", "under", "sale", "new", "drop", "drops",
    "apparel", "clothing", "sneakers", "sneaker", "shoes", "shoe", "footwear",
    "watches", "watch", "accessories", "accessory", "bags", "bag", "perfumes", "perfume", "beauty"
  ]);
  return [...new Set(
    `${handle || ""} ${title || ""}`
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .split(/\s+/)
      .map((term) => term.trim())
      .filter((term) => term && !genericTerms.has(term))
  )];
};

const productMatchesTerms = (product, terms, rules = {}) => {
  if (rules.priceMax && (!(Number(product.price || 0) > 0) || Number(product.price || 0) > rules.priceMax)) return false;
  if (rules.saleMode && !productMatchesSale(product)) return false;
  if (rules.brandTerms?.length && !productMatchesBrand(product, rules.brandTerms)) return false;
  if (rules.categoryKeys?.length && !productMatchesCategory(product, rules.categoryKeys)) return false;
  if (rules.specificTerms?.length) {
    const tokens = productTokens(product);
    if (!rules.specificTerms.every((term) => tokens.includes(term))) return false;
  }
  if (!rules.categoryKeys?.length && terms.length) {
    const tokens = productTokens(product);
    if (!terms.every((term) => tokens.includes(term))) return false;
  }
  return true;
};

const collectionRulesForPlp = (handle, title = "", chips = "") => {
  const under = String(handle || "").match(/under[-_]?(\d+)/i);
  const intent = intentFromContext(handle, title, chips);
  return {
    priceMax: under ? Number(under[1]) || 0 : 0,
    maxItems: String(handle || "").includes("top-50") ? 50 : 0,
    brandKeys: intent.brandKeys,
    brandTerms: intent.brandTerms,
    categoryKeys: intent.categoryKeys,
    saleMode: intent.saleMode,
    specificTerms: specificTermsForHandle(handle, title).filter((term) => !intent.brandTerms.includes(term) && !intent.categoryTerms.includes(term))
  };
};

const sortProductsForPlp = (products, sortBy) => {
  const sorted = [...products];
  switch (sortBy) {
    case "title-ascending":
      return sorted.sort((a, b) => String(a.title).localeCompare(String(b.title)));
    case "title-descending":
      return sorted.sort((a, b) => String(b.title).localeCompare(String(a.title)));
    case "price-ascending":
      return sorted.sort((a, b) => Number(a.price || 0) - Number(b.price || 0));
    case "price-descending":
      return sorted.sort((a, b) => Number(b.price || 0) - Number(a.price || 0));
    case "created-ascending":
      return sorted.sort((a, b) => Date.parse(a.created_at || 0) - Date.parse(b.created_at || 0));
    case "created-descending":
      return sorted.sort((a, b) => Date.parse(b.created_at || 0) - Date.parse(a.created_at || 0));
    case "best-selling":
    case "manual":
    default:
      return sorted.sort((a, b) => popularityScore(b) - popularityScore(a));
  }
};

const selectedClientFilters = (plp) => {
  const values = {};
  plp.querySelectorAll("[data-client-filter]:checked").forEach((input) => {
    const key = input.getAttribute("data-client-filter");
    if (!values[key]) values[key] = new Set();
    values[key].add(input.value.toLowerCase());
  });
  return values;
};

const applyClientFilters = (products, filters) => products.filter((product) => {
  const tokens = productTokens(product);
  if (filters.vendor?.size && !filters.vendor.has(String(product.vendor || "").toLowerCase())) return false;
  if (filters.type?.size && !filters.type.has(String(product.product_type || "").toLowerCase())) return false;
  if (filters.tag?.size && !Array.from(filters.tag).some((tag) => tokens.includes(tag))) return false;
  if (filters.available?.size) {
    const inStock = Boolean(product.available ?? product.variants?.some((variant) => variant.available));
    if (filters.available.has("1") && !inStock) return false;
    if (filters.available.has("0") && inStock) return false;
  }
  if (filters.priceMin && Number(product.price || 0) < filters.priceMin) return false;
  if (filters.priceMax && Number(product.price || 0) > filters.priceMax) return false;
  return true;
});

const selectedUrlFilters = () => {
  const params = new URLSearchParams(window.location.search);
  const filters = {};
  params.forEach((value, key) => {
    const lowerKey = key.toLowerCase();
    const lowerValue = String(value || "").toLowerCase();
    if (lowerKey.includes("vendor")) {
      if (!filters.vendor) filters.vendor = new Set();
      filters.vendor.add(lowerValue);
    } else if (lowerKey.includes("product_type")) {
      if (!filters.type) filters.type = new Set();
      filters.type.add(lowerValue);
    } else if (lowerKey.includes("tag")) {
      if (!filters.tag) filters.tag = new Set();
      filters.tag.add(lowerValue);
    } else if (lowerKey.includes("availability") || lowerKey.includes("available")) {
      if (!filters.available) filters.available = new Set();
      filters.available.add(lowerValue);
    } else if (lowerKey.includes("price") && (lowerKey.includes("gte") || lowerKey.includes("min"))) {
      filters.priceMin = Number(value || 0) || 0;
    } else if (lowerKey.includes("price") && (lowerKey.includes("lte") || lowerKey.includes("max"))) {
      filters.priceMax = Number(value || 0) || 0;
    }
  });
  return filters;
};

const extractProductHandlesFromHtml = (html) => {
  const seen = new Set();
  const handles = [];
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc.querySelectorAll('[data-product-grid] .ff-product-card a[href*="/products/"]').forEach((link) => {
      const match = link.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
      const handle = match?.[1];
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      handles.push(handle);
    });
  } catch {
    const matches = html.match(/\/products\/([^"'?#]+)/g) || [];
    matches.forEach((match) => {
      const handle = match.replace("/products/", "");
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      handles.push(handle);
    });
  }
  return handles;
};

const fetchAllSearchHandles = async (baseUrl, pageSize = 24, maxPages = 12) => {
  const handles = [];
  const seen = new Set();
  for (let page = 1; page <= maxPages; page += 1) {
    const pageUrl = new URL(baseUrl.toString());
    if (page > 1) pageUrl.searchParams.set("page", String(page));
    else pageUrl.searchParams.delete("page");
    const response = await fetch(pageUrl.toString(), { headers: { Accept: "text/html" } });
    if (!response.ok) break;
    const html = await response.text();
    const pageHandles = extractProductHandlesFromHtml(html);
    pageHandles.forEach((handle) => {
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      handles.push(handle);
    });
    if (!pageHandles.length || pageHandles.length < pageSize) break;
  }
  return handles;
};

const searchQueryTokens = (value) => String(value || "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, " ")
  .split(/\s+/)
  .map((token) => token.trim())
  .filter((token) => token.length > 1);

const productMatchesSearchQuery = (product, query) => {
  const tokens = searchQueryTokens(query);
  if (!tokens.length) return true;
  const haystack = [
    product?.handle,
    product?.title,
    product?.vendor,
    product?.product_type,
    ...(Array.isArray(product?.tags) ? product.tags : String(product?.tags || "").split(","))
  ]
    .join(" ")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ");
  return tokens.every((token) => haystack.includes(token));
};

const buildClientFilterOptions = (products) => {
  const collect = (getter) => {
    const counts = new Map();
    products.forEach((product) => {
      const raw = getter(product);
      const values = Array.isArray(raw) ? raw : [raw];
      values.forEach((value) => {
        const label = String(value || "").trim();
        if (!label || ["lux-outlet", "sourcex"].includes(label.toLowerCase())) return;
        counts.set(label, (counts.get(label) || 0) + 1);
      });
    });
    return Array.from(counts.entries()).sort((a, b) => b[1] - a[1]).slice(0, 20);
  };
  return {
    Brand: ["vendor", collect((product) => product.vendor)],
    "Product type": ["type", collect((product) => product.product_type)],
    More: ["tag", collect((product) => product.tags)]
  };
};

const clientFilterMarkup = (products) => {
  const groups = buildClientFilterOptions(products);
  return Object.entries(groups).map(([label, [key, options]], index) => `
    <details ${index === 0 ? "open" : ""}>
      <summary>${escapeHtml(label)}</summary>
      ${options.map(([option, count]) => `
        <label>
          <input type="checkbox" value="${escapeHtml(option)}" data-client-filter="${key}">
          <span>${escapeHtml(option)}</span>
          <small>${count}</small>
        </label>
      `).join("")}
    </details>
  `).join("");
};

const mobileClientFilterMarkup = (products) => {
  const groups = buildClientFilterOptions(products);
  return Object.entries(groups).slice(0, 3).map(([label, [key, options]]) => `
    <details class="ff-mobile-filter-menu">
      <summary>${escapeHtml(label)} <span>?</span></summary>
      <div class="ff-mobile-filter-menu__panel">
        ${options.slice(0, 16).map(([option]) => `
          <label>
            <input type="checkbox" value="${escapeHtml(option)}" data-client-filter="${key}">
            <span>${escapeHtml(option)}</span>
          </label>
        `).join("")}
      </div>
    </details>
  `).join("");
};

const initPopularityPlp = async () => {
  const plp = document.querySelector("[data-plp-popularity]");
  const grid = plp?.querySelector("[data-product-grid]");
  if (!plp || !grid || plp.dataset.popularityReady === "true") return;

  const url = new URL(window.location.href);
  const isSearchRoute = url.pathname === "/search" || url.searchParams.has("q");
  const handle = plp.getAttribute("data-collection-handle") || location.pathname.match(/\/collections\/([^/?#]+)/)?.[1] || "all";
  const title = plp.getAttribute("data-collection-title") || "";
  const chips = plp.getAttribute("data-filter-chips") || "";
  const isSearchMode = plp.getAttribute("data-search-mode") === "true" || isSearchRoute;
  const intent = collectionRulesForPlp(handle, title, chips);
  const terms = intent.categoryTerms || [];
  const searchTerms = plp.getAttribute("data-search-terms") || url.searchParams.get("q") || "";
  plp.dataset.popularityReady = "true";
  const cleanUrl = new URL(window.location.href);
  if (cleanUrl.searchParams.get("sort_by") === "best-selling") {
    cleanUrl.searchParams.delete("sort_by");
    window.history.replaceState(window.history.state, "", cleanUrl.toString());
  }

  if (isSearchMode) {
    const allProducts = await loadPopularityProducts();
    const countNode = plp.querySelector(".ff-plp__count");
    const nativeTotalCount = Math.max(0, Number(plp.getAttribute("data-total-results") || 0) || 0);
    const pagination = plp.querySelector("[data-pagination]") || plp.querySelector(".ff-pagination");
    const pageSize = Math.max(24, grid.querySelectorAll(".ff-product-card").length || 24);
    let visibleCount = pageSize;
    const renderSearchResults = () => {
      if (!searchQueryTokens(searchTerms).length) return;
      const sortSelect = plp.querySelector("[data-sort-select]");
      const selectedSort = sortSelect?.value || "best-selling";
      const normalizedSort = selectedSort === "relevance" ? "best-selling" : selectedSort;
      const filters = { ...selectedUrlFilters(), ...selectedClientFilters(plp) };
      const matchedProducts = allProducts.filter((product) => productMatchesSearchQuery(product, searchTerms));
      const filtered = applyClientFilters(matchedProducts, filters);
      const sorted = sortProductsForPlp(filtered, normalizedSort);
      const page = sorted.slice(0, visibleCount);
      if (countNode) countNode.textContent = `${filtered.length || nativeTotalCount} Items`;
      grid.innerHTML = page.length ? page.map(homeRailProductCard).join("") : `<p>No products found for "${escapeHtml(searchTerms)}".</p>`;
      if (pagination) {
        pagination.innerHTML = sorted.length > visibleCount
          ? '<button class="ff-view-more" type="button" data-client-view-more>View More</button>'
          : "";
      }
      window.__luxePopularitySearch = {
        query: searchTerms,
        nativeTotal: nativeTotalCount,
        total: filtered.length,
        visible: page.length,
        first: page.slice(0, 12).map((product) => ({
          handle: product.handle,
          title: product.title,
          vendor: product.vendor,
          score: popularityScore(product)
        }))
      };
      setWishlistState();
      window.__luxePostAppendPlp = renderSearchResults;
    };

    plp.addEventListener("change", (event) => {
      if (!event.target.closest("[data-sort-select]")) return;
      visibleCount = pageSize;
      renderSearchResults();
    });
    plp.addEventListener("click", (event) => {
      if (!event.target.closest("[data-client-view-more]")) return;
      event.preventDefault();
      visibleCount += pageSize;
      renderSearchResults();
    });
    renderSearchResults();
    return;
  }

  const popularityProducts = await loadPopularityProducts();
  const rules = intent;
  let baseProducts = [];
  try {
    const collectionProducts = await fetchAllCollectionProducts(handle);
    baseProducts = withPopularityScores(collectionProducts, popularityProducts).filter((product) => productMatchesTerms(product, terms, rules));
  } catch (error) {
    console.warn("[Luxe] Falling back to popularity dataset for collection page", handle, error);
    baseProducts = popularityProducts.filter((product) => productMatchesTerms(product, terms, rules));
  }
  if (rules.maxItems) baseProducts = sortProductsForPlp(baseProducts, "best-selling").slice(0, rules.maxItems);
  const countNode = plp.querySelector(".ff-plp__count");
  const pagination = plp.querySelector("[data-pagination]") || plp.querySelector(".ff-pagination");
  const pageSize = Math.max(24, grid.querySelectorAll(".ff-product-card").length || 24);
  let visibleCount = pageSize;

  const render = () => {
    const sortSelect = plp.querySelector("[data-sort-select]");
    const filters = selectedUrlFilters();
    const filtered = applyClientFilters(baseProducts, filters);
    const selectedSort = sortSelect?.value || "best-selling";
    const normalizedSort = selectedSort === "relevance" ? "best-selling" : selectedSort;
    const sorted = sortProductsForPlp(filtered, normalizedSort);
    const page = sorted.slice(0, visibleCount);
    grid.innerHTML = page.map(homeRailProductCard).join("");
    plp.dataset.popularityRendered = "true";
    window.__luxePopularityPlp = {
      handle,
      terms,
      baseCount: baseProducts.length,
      filteredCount: filtered.length,
      visibleCount: page.length,
      first: page.slice(0, 8).map((product) => ({
        handle: product.handle,
        title: product.title,
        vendor: product.vendor,
        score: popularityScore(product)
      }))
    };
    if (countNode) countNode.textContent = `${filtered.length} Items`;
    if (pagination) {
      pagination.innerHTML = sorted.length > visibleCount
        ? '<button class="ff-view-more" type="button" data-client-view-more>View More</button>'
        : "";
    }
    setWishlistState();
  };

  plp.addEventListener("change", (event) => {
    if (!event.target.closest("[data-sort-select]")) return;
    visibleCount = pageSize;
    render();
  });
  plp.addEventListener("click", (event) => {
    if (event.target.closest("[data-client-view-more]")) {
      event.preventDefault();
      visibleCount += pageSize;
      render();
    }
    if (event.target.closest("[data-client-filter-apply]")) {
      event.preventDefault();
      render();
    }
  });
  render();
};

const ensureMobileSearch = () => {
  const header = document.querySelector(".ff-header__mobile");
  if (!header || header.querySelector("[data-mobile-search-form]")) return;

  const searchLink = header.querySelector('a.ff-icon-button[href="/search"], a.ff-icon-button[href^="/search?"]');
  if (!searchLink) return;

  const iconHtml = searchLink.innerHTML;
  const button = document.createElement("button");
  button.className = searchLink.className;
  button.type = "button";
  button.setAttribute("data-mobile-search-open", "");
  button.setAttribute("aria-label", searchLink.getAttribute("aria-label") || "Search");
  button.innerHTML = iconHtml;
  searchLink.replaceWith(button);

  const form = document.createElement("form");
  form.className = "ff-mobile-search";
  form.action = "/search";
  form.method = "get";
  form.role = "search";
  form.setAttribute("data-mobile-search-form", "");
  form.innerHTML = `
    <input type="hidden" name="type" value="product">
    ${iconHtml}
    <input type="search" name="q" placeholder="Search" autocomplete="off" data-mobile-search-input>
    <button class="ff-icon-button" type="button" data-mobile-search-close aria-label="Close search">ï¿½</button>
  `;
  header.appendChild(form);
};

const normalizePdpMedia = () => {
  const gallery = document.querySelector(".ff-pdp__media");
  if (!gallery || gallery.dataset.luxePdpMediaExpanded === "true") return;

  const images = Array.from(gallery.querySelectorAll(":scope > .ff-pdp__image"));
  if (images.length <= 5) return;

  let more = gallery.querySelector(".ff-pdp__media-more");
  if (!more) {
    more = document.createElement("div");
    more.className = "ff-pdp__media-more";
    more.innerHTML = '<button type="button" class="ff-pdp__view-more" data-pdp-media-view-more>View More</button>';
  }

  const moreButton = more.querySelector("[data-pdp-media-view-more]");
  if (moreButton) {
    moreButton.style.setProperty("display", "inline-flex", "important");
    moreButton.style.setProperty("align-items", "center", "important");
    moreButton.style.setProperty("justify-content", "center", "important");
  }

  images.forEach((image, index) => {
    if (index > 3) {
      image.hidden = true;
      image.classList.add("is-hidden");
      image.setAttribute("data-pdp-extra-media", "");
    } else {
      image.hidden = false;
      image.classList.remove("is-hidden");
      image.removeAttribute("data-pdp-extra-media");
    }
  });

  images[3].after(more);
};

const homeRailProductCard = (product) => {
  const image = productImageUrl(product);
  const price = Number(product.variants?.[0]?.price || product.price || 0);
  const compare = Number(product.variants?.[0]?.compare_at_price || product.compare_at_price || (price ? price * 1.5 : 0));
  const title = escapeHtml(product.title);
  const vendor = escapeHtml(product.vendor || "");
  const url = `/products/${product.handle}`;
  return `
    <article class="ff-product-card" data-product-card data-product-id="${product.id || ""}">
      <div class="ff-product-card__media-wrap">
        <a class="ff-product-card__media" href="${url}" aria-label="${title}">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy" sizes="(max-width: 749px) 58vw, 25vw">` : '<div class="ff-placeholder" aria-hidden="true"></div>'}
        </a>
      </div>
      <a class="ff-product-card__info" href="${url}">
        ${vendor ? `<span class="ff-product-card__vendor">${vendor}</span>` : ""}
        <span class="ff-product-card__title" title="${title}">${title}</span>
        <span class="ff-product-card__price">
          ${compare ? `<s>${formatStorefrontPrice(compare)}</s>` : ""}
          ${price ? `<strong>${formatStorefrontPrice(price)}</strong>` : ""}
        </span>
      </a>
    </article>
  `;
};

const hydrateEmptyHomeProductRails = async () => {
  const rails = Array.from(document.querySelectorAll(".ff-home .ff-product-rail"));
  await Promise.all(rails.map(async (rail) => {
    const existingHandles = new Set(
      Array.from(rail.querySelectorAll('.ff-product-card a[href*="/products/"]'))
        .map((link) => link.getAttribute("href")?.match(/\/products\/([^/?#]+)/)?.[1])
        .filter(Boolean)
    );
    const sectionHeading = rail.closest(".ff-home-rail")?.querySelector(".ff-section-heading h2, h2")?.textContent?.trim().toLowerCase() || "";
    let requestedHandle = rail.getAttribute("data-collection-handle") || "";
    const railTags = rail.getAttribute("data-rail-tags") || "";
    if ((requestedHandle === "all" || requestedHandle === "sneakers-auto") && sectionHeading.includes("sneaker")) {
      requestedHandle = "sneakers";
    }
    if (!requestedHandle) {
      if (sectionHeading.includes("drop")) requestedHandle = "luxe-sale";
      else if (sectionHeading.includes("new")) requestedHandle = "new";
      else if (sectionHeading.includes("sneaker")) requestedHandle = "sneakers";
      else if (sectionHeading.includes("bag") || sectionHeading.includes("accessor")) requestedHandle = "bags-edit";
      else if (sectionHeading.includes("offer") || sectionHeading.includes("sale")) requestedHandle = "luxe-sale";
      else requestedHandle = "all";
    }
    const limit = Number(rail.getAttribute("data-product-limit") || 12);
    const minimumCards = Math.max(limit || 12, 8);
    const rules = collectionRulesForPlp(requestedHandle, sectionHeading, railTags);

    const handles = requestedHandle && requestedHandle !== "all"
      ? [requestedHandle]
      : [...new Set([requestedHandle, "new", "luxe-sale", "all"].filter(Boolean))];
    const collected = [];
    for (const handle of handles) {
      try {
        const products = await fetchCollectionProducts(handle);
        products.forEach((product) => {
          if (product.handle && !collected.some((item) => item.handle === product.handle)) collected.push(product);
        });
      } catch {
        /* Try the next fallback collection. */
      }
    }
    const ranked = sortProductsForPlp(
      collected.filter((product) => productMatchesTerms(product, rules.categoryTerms || [], rules)),
      "best-selling"
    )
      .filter((product) => product.handle)
      .slice(0, minimumCards);
    if (ranked.length) {
      rail.innerHTML = ranked.map(homeRailProductCard).join("");
      ranked.forEach((product) => existingHandles.add(product.handle));
    }
  }));
  fixHomeRailScroll();
};

const populatePdpRecommendations = async () => {
  const handle = currentProductHandle();
  if (!handle || document.documentElement.dataset.luxeRecommendationsReady === "true") return;
  const tracks = Array.from(document.querySelectorAll(".ff-pdp-rail__track"));
  if (!tracks.length) return;
  document.documentElement.dataset.luxeRecommendationsReady = "true";

  let currentProduct;
  try {
    currentProduct = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: "application/json" } }).then((response) => response.json());
  } catch {
    currentProduct = null;
  }
  if (!currentProduct) return;

    const collectionHandle = document.querySelector('.ff-pdp__breadcrumbs a[href*="/collections/"]')?.getAttribute("href")?.match(/\/collections\/([^/?#]+)/)?.[1]
    || document.querySelector('.ff-breadcrumbs a[href*="/collections/"]')?.getAttribute("href")?.match(/\/collections\/([^/?#]+)/)?.[1]
    || "all";
    const brandHandle = handleize(currentProduct.vendor);
    const popularityProducts = await loadPopularityProducts().catch(() => []);

  await Promise.all(tracks.map(async (track) => {
    const isBrandRail = Boolean(track.closest(".ff-pdp-rail--brand"));
    const collectionRules = collectionRulesForPlp(collectionHandle, collectionHandle.replace(/-/g, " "));
    let ranked = [];
    if (isBrandRail) {
      const brandSources = [];
      for (const collection of [...new Set([brandHandle, collectionHandle].filter(Boolean))]) {
        try {
          const products = await fetchAllCollectionProducts(collection, 6);
          brandSources.push(...products);
        } catch {
          /* Keep the existing Liquid recommendations if this source is unavailable. */
        }
      }
      const normalizeBrandProducts = (products, requireCategory) => {
        const seen = new Set();
        return products
          .filter((product) => product.handle && product.handle !== handle)
          .filter((product) => productMatchesBrand(product, [currentProduct.vendor]))
          .filter((product) => {
            if (!requireCategory || !collectionRules.categoryKeys.length) return true;
            return productMatchesCategory(product, collectionRules.categoryKeys);
          })
          .filter(hasProductImage)
          .filter((product) => {
            const key = product.handle;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
      };
      const sameCategoryBrandProducts = normalizeBrandProducts([...brandSources, ...popularityProducts], true);
      const anyBrandProducts = normalizeBrandProducts([...brandSources, ...popularityProducts], false);
      ranked = sortProductsForPlp(
        sameCategoryBrandProducts.length >= 4 ? sameCategoryBrandProducts : anyBrandProducts,
        "best-selling"
      ).slice(0, 16);
    } else {
      let recommendationProducts = [];
      try {
        const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(currentProduct.id)}&limit=14&intent=related`, {
          headers: { Accept: "application/json" }
        });
        const data = response.ok ? await response.json() : { products: [] };
        recommendationProducts = data.products || [];
      } catch {
        recommendationProducts = [];
      }
      const seen = new Set();
      ranked = sortProductsForPlp(
        [...recommendationProducts, ...popularityProducts]
          .filter((product) => product.handle && product.handle !== handle)
          .filter((product) => !collectionRules.categoryKeys.length || productMatchesCategory(product, collectionRules.categoryKeys))
          .filter(hasProductImage)
          .filter((product) => {
            const key = product.handle;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          }),
        "best-selling"
      ).slice(0, 14);
    }
    if (ranked.length) {
      track.innerHTML = ranked.map(homeRailProductCard).join("");
    }
  }));
  fixHomeRailScroll();
};

const ensureSideCart = () => {
  let overlay = document.querySelector("[data-side-cart-overlay]");
  let drawer = document.querySelector("[data-side-cart]");
  if (overlay && drawer) return drawer;

  overlay = document.createElement("button");
  overlay.type = "button";
  overlay.className = "ff-side-cart-overlay";
  overlay.setAttribute("data-side-cart-overlay", "");
  overlay.setAttribute("aria-label", "Close shopping bag");

  drawer = document.createElement("aside");
  drawer.className = "ff-side-cart";
  drawer.setAttribute("data-side-cart", "");
  drawer.setAttribute("aria-label", "Shopping bag");
  drawer.innerHTML = `
    <div class="ff-side-cart__header">
      <h2 class="ff-side-cart__title">Shopping Bag</h2>
      <button class="ff-side-cart__close" type="button" data-side-cart-close aria-label="Close shopping bag">&times;</button>
    </div>
    <div class="ff-side-cart__body" data-side-cart-body></div>
    <div class="ff-side-cart__footer" data-side-cart-footer></div>
  `;

  document.body.append(overlay, drawer);
  return drawer;
};

const closeSideCart = () => {
  document.body.classList.remove("ff-side-cart-open");
};

const renderSideCart = (cart) => {
  const drawer = ensureSideCart();
  const body = drawer.querySelector("[data-side-cart-body]");
  const footer = drawer.querySelector("[data-side-cart-footer]");
  const count = document.querySelector("[data-cart-count]");
  if (count) count.textContent = cart.item_count;

  if (!cart.items.length) {
    body.innerHTML = "<p>Your shopping bag is empty.</p>";
    footer.innerHTML = '<a class="ff-side-cart__view" href="/collections/all">Continue shopping</a>';
    return;
  }

  body.innerHTML = cart.items.map((item) => `
    <article class="ff-side-cart__item">
      ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ""}
      <div class="ff-side-cart__item-main">
        <div class="ff-side-cart__item-top">
          <div class="ff-side-cart__item-title">${item.product_title}</div>
          <button class="ff-side-cart__remove" type="button" data-side-cart-remove="${item.key}">Remove</button>
        </div>
        <div class="ff-side-cart__item-meta">${item.variant_title || ""}</div>
        <div class="ff-side-cart__item-bottom">
          <div class="ff-side-cart__qty" style="display:inline-flex;align-items:center;border:1px solid var(--ff-border,#e2e2e2);border-radius:8px;overflow:hidden;"><button type="button" data-side-cart-minus="${item.key}" aria-label="Decrease quantity" style="width:30px;height:30px;border:0;background:transparent;cursor:pointer;font-size:17px;line-height:1;color:inherit;">&minus;</button><span class="ff-side-cart__qty-val" style="min-width:30px;text-align:center;font-size:13px;font-variant-numeric:tabular-nums;">${item.quantity}</span><button type="button" data-side-cart-plus="${item.key}" aria-label="Increase quantity" style="width:30px;height:30px;border:0;background:transparent;cursor:pointer;font-size:16px;line-height:1;color:inherit;">+</button></div>
          <div class="ff-side-cart__item-price">${money(item.final_line_price)}</div>
        </div>
      </div>
    </article>
  `).join("");

  footer.innerHTML = `
    <p class="ff-side-cart__subtotal"><span>Estimated Total</span><span>${money(cart.total_price)}</span></p>
    <a class="ff-side-cart__checkout" href="/checkout">Check out</a>
  `;
};

const openSideCart = async () => {
  const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((response) => response.json());
  renderSideCart(cart);
  document.body.classList.add("ff-side-cart-open");
};

const removeSideCartItem = async (key) => {
  if (!key) return;
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  if (!response.ok) throw new Error("Could not remove item from cart");
  const cart = await response.json();
  renderSideCart(cart);
};

const updateSideCartQty = async (key, quantity) => {
  if (!key) return;
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  });
  const cart = response.ok
    ? await response.json()
    : await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  renderSideCart(cart);
};

const initAjaxCart = () => {
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      if (!window.matchMedia("(min-width: 990px)").matches) return;
      event.preventDefault();
      const submit = form.querySelector('button[type="submit"]');
      const previous = submit?.textContent;
      if (submit) {
        submit.disabled = true;
        submit.textContent = "Adding...";
      }
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error("Could not add item to cart");
        await openSideCart();
      } catch {
        form.submit();
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = previous || "Add to bag";
        }
      }
    });
  });
};

const initHomeProductCarousel = () => {
  document.querySelectorAll("[data-home-product-carousel]").forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll("[data-home-product-slide]"));
    const dots = Array.from(carousel.querySelectorAll("[data-home-product-dot]"));
    if (!slides.length) return;

    let active = Math.floor((slides.length - 1) / 2);
    const render = () => {
      slides.forEach((slide, index) => {
        const offset = index - active;
        slide.classList.toggle("is-active", index === active);
        slide.style.setProperty("--offset", offset);
        slide.style.setProperty("--abs-offset", Math.abs(offset));
      });
      dots.forEach((dot, index) => dot.classList.toggle("is-active", index === active));
    };

    dots.forEach((dot, index) => dot.addEventListener("click", () => {
      active = index;
      render();
    }));

    carousel.addEventListener("click", (event) => {
      const slide = event.target.closest("[data-home-product-slide]");
      if (!slide || slide.classList.contains("is-active")) return;
      event.preventDefault();
      active = slides.indexOf(slide);
      render();
    });

    render();
  });
};

const initHeroBannerCarousel = () => {
  document.querySelectorAll("[data-hero-carousel]").forEach((section) => {
    if (section.dataset.heroCarouselReady === "true") return;
    section.dataset.heroCarouselReady = "true";

    const rail = section.querySelector("[data-hero-rail]");
    const prev = section.querySelector("[data-hero-prev]");
    const next = section.querySelector("[data-hero-next]");
    if (!rail) return;

    let paused = false;
    let resumeTimer;
    const step = () => {
      const firstSlide = rail.querySelector(".ff-luxe-hero__banner");
      if (!firstSlide) return rail.clientWidth;
      return firstSlide.getBoundingClientRect().width;
    };

    const sync = () => {
      const canScroll = rail.scrollWidth > rail.clientWidth + 2;
      prev?.classList.toggle("is-disabled", !canScroll);
      next?.classList.toggle("is-disabled", !canScroll);
    };

    const move = (direction = 1) => {
      if (rail.scrollWidth <= rail.clientWidth + 2) return;
      const max = rail.scrollWidth - rail.clientWidth;
      const atEnd = rail.scrollLeft >= max - 4;
      const atStart = rail.scrollLeft <= 4;
      if (direction > 0 && atEnd) {
        rail.scrollTo({ left: 0, behavior: "smooth" });
        return;
      }
      if (direction < 0 && atStart) {
        rail.scrollTo({ left: max, behavior: "smooth" });
        return;
      }
      rail.scrollBy({ left: direction * step(), behavior: "smooth" });
    };

    const pauseBriefly = () => {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        paused = false;
      }, 5000);
    };

    prev?.addEventListener("click", (event) => {
      event.preventDefault();
      pauseBriefly();
      move(-1);
    });
    next?.addEventListener("click", (event) => {
      event.preventDefault();
      pauseBriefly();
      move(1);
    });

    ["pointerenter", "focusin", "touchstart", "wheel"].forEach((type) => {
      section.addEventListener(type, pauseBriefly, { passive: true });
    });
    section.addEventListener("pointerleave", () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        paused = false;
      }, 1200);
    });
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);

    sync();
    setInterval(() => {
      if (!paused) move(1);
    }, 3000);
  });
};

const centerHomeProductCarousels = () => {
  document.querySelectorAll("[data-home-product-carousel]").forEach((carousel) => {
    const baseStyles = {
      display: "block",
      visibility: "visible",
      opacity: "1",
      position: "relative",
      left: "50%",
      right: "auto",
      width: "100vw",
      maxWidth: "100vw",
      marginTop: "20px",
      marginRight: "0",
      marginBottom: "20px",
      marginLeft: "-50vw",
      overflow: "hidden",
      textAlign: "center",
      transform: "none",
    };

    Object.entries(baseStyles).forEach(([property, value]) => {
      carousel.style.setProperty(property.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`), value, "important");
    });

    carousel.querySelectorAll(".ff-home-recommendations__stage").forEach((stage) => {
      stage.style.setProperty("width", "100vw", "important");
      stage.style.setProperty("max-width", "100vw", "important");
      stage.style.setProperty("height", window.matchMedia("(max-width: 749px)").matches ? "422px" : "562px", "important");
      stage.style.setProperty("margin-left", "auto", "important");
      stage.style.setProperty("margin-right", "auto", "important");
      stage.style.setProperty("overflow", "visible", "important");
    });

    carousel.querySelectorAll(".ff-home-recommendations__slide").forEach((slide) => {
      slide.style.setProperty("left", "50%", "important");
      slide.style.setProperty("margin-left", "0", "important");
    });

    requestAnimationFrame(() => {
      carousel.style.setProperty("transform", "none", "important");
      const left = carousel.getBoundingClientRect().left;
      if (Math.abs(left) > 1) {
        carousel.style.setProperty("transform", `translateX(${-left}px)`, "important");
      }
    });
  });
};

const enforceMobileLayoutFixes = () => {
  if (!document.getElementById("ff-live-mobile-layout-fixes")) {
    const style = document.createElement("style");
    style.id = "ff-live-mobile-layout-fixes";
    style.textContent = `
      .ff-home .ff-home-recommendations,
      .ff-home-recommendations {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        left: 50% !important;
        right: auto !important;
        width: 100vw !important;
        max-width: 100vw !important;
        margin-left: -50vw !important;
        margin-right: 0 !important;
        transform: none !important;
        overflow: hidden !important;
        text-align: center !important;
      }

      .ff-home-recommendations__stage {
        width: 100vw !important;
        max-width: 100vw !important;
        height: 562px !important;
        margin-left: auto !important;
        margin-right: auto !important;
        overflow: visible !important;
      }

      .ff-home-recommendations__dots {
        margin-top: 2px !important;
      }

      .ff-home-recommendations__slide {
        left: 50% !important;
        transform: translateX(calc(-50% + (var(--offset) * 290px))) scale(calc(1 - (var(--abs-offset) * .08))) !important;
      }

      @media (max-width: 749px) {
        .ff-plp .ff-refinement-bar,
        .ff-plp .ff-refinement-bar.is-open,
        .ff-plp__filters.is-open .ff-refinement-bar {
          display: none !important;
          visibility: hidden !important;
          height: 0 !important;
          max-height: 0 !important;
          overflow: hidden !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
        }

        .ff-plp__mobile-controls {
          display: none !important;
          visibility: hidden !important;
          height: 0 !important;
          max-height: 0 !important;
          overflow: hidden !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .ff-plp__body {
          display: block !important;
          padding: 0 !important;
        }

        .ff-home .ff-home-recommendations,
        .ff-home-recommendations {
          padding: 14px 0 18px !important;
        }

        .ff-home-recommendations__stage {
          width: 100vw !important;
          max-width: 100vw !important;
          height: 422px !important;
          margin: 0 auto !important;
          overflow: visible !important;
        }

        .ff-home-recommendations__slide {
          left: 50% !important;
          transform: translateX(calc(-50% + (var(--offset) * 210px))) scale(calc(1 - (var(--abs-offset) * .08))) !important;
        }
      }
    `;
    document.head.append(style);
  }

  if (window.matchMedia("(max-width: 749px)").matches) {
    document.querySelectorAll("[data-filter-panel]").forEach((panel) => {
      panel.classList.remove("is-open");
      panel.setAttribute("hidden", "");
      panel.style.setProperty("display", "none", "important");
    });
    document.querySelector("[data-filter-form]")?.classList.remove("is-open");
  }

  document.querySelectorAll("[data-home-product-carousel]").forEach((carousel) => {
    carousel.style.setProperty("display", "block", "important");
    carousel.style.setProperty("position", "relative", "important");
    carousel.style.setProperty("left", "50%", "important");
    carousel.style.setProperty("width", "100vw", "important");
    carousel.style.setProperty("max-width", "100vw", "important");
    carousel.style.setProperty("margin-left", "-50vw", "important");
    carousel.style.setProperty("margin-right", "0", "important");
    carousel.style.setProperty("transform", "none", "important");
  });
  centerHomeProductCarousels();
};

const mountHomeProductCarouselFallback = async () => {
  if (document.querySelector("[data-home-product-carousel]")) return;
  const hero = document.querySelector(".ff-luxe-hero");
  if (!hero) return;
  try {
    const data = await fetch("/collections/all/products.json?limit=9", { headers: { Accept: "application/json" } }).then((response) => response.json());
    const products = data.products || [];
    if (!products.length) return;
    const section = document.createElement("section");
    section.className = "ff-home-recommendations";
    section.setAttribute("data-home-product-carousel", "");
    section.innerHTML = `
      <h2>Your Recommended Products</h2>
      <div class="ff-home-recommendations__stage">
        ${products.map((product) => `
          <a class="ff-home-recommendations__slide" href="/products/${product.handle}" data-home-product-slide>
            <span class="ff-home-recommendations__media">
              ${product.images?.[0]?.src ? `<img src="${product.images[0].src}" alt="${product.title}">` : '<span class="ff-image-placeholder" aria-hidden="true"><span>PLACEHOLDER</span></span>'}
            </span>
            <span class="ff-home-recommendations__title">${product.vendor || product.title}</span>
          </a>
        `).join("")}
      </div>
      <div class="ff-home-recommendations__dots" aria-hidden="true">
        ${products.map(() => '<button type="button" data-home-product-dot></button>').join("")}
      </div>
    `;
    hero.insertAdjacentElement("afterend", section);
    initHomeProductCarousel();
  } catch {
    /* storefront JSON can be unavailable on some themes; leave homepage unchanged in that case */
  }
};

const normalizeFooter = () => {
  const html = `
    <div>
      <h2>Most Viewed</h2>
      <a href="/collections/under-10000">Under 10,000</a>
      <a href="/collections/under-20000">Under 20,000</a>
      <a href="/collections/sneakers">Sneakers</a>
      <a href="/collections/watches">Watches</a>
      <a href="/collections/accessories-edit">Accessories</a>
    </div>
    <div>
      <h2>Top 50</h2>
      <a href="/collections/top-50-watches">Top 50 watches</a>
      <a href="/collections/top-50-sneakers">Top 50 sneakers</a>
      <a href="/collections/top-50-apparel">Top 50 apparel</a>
      <a href="/collections/top-50-accessories">Top 50 accessories</a>
    </div>
    <div>
      <h2>Know More</h2>
      <a href="/pages/about-us">About Us</a>
      <a href="/pages/cancellations-and-returns">Cancellations & Returns</a>
      <a href="/pages/cash-on-delivery-policy">Cash on Delivery Policy</a>
      <a href="/pages/shipping">Shipping</a>
      <a href="/pages/terms-conditions">Terms & Conditions</a>
      <a href="/pages/privacy-policy">Privacy Policy</a>
    </div>
    <div>
      <h2>Contact Us</h2>
      <p>Monday to Saturday, 10:30am to 7:00pm</p>
      <p>Support: <a href="mailto:info@luxe-outlet.com">info@luxe-outlet.com</a></p>
      <p>Pocket 8, Block B, Rohini Sector 15, New Delhi - 110089</p>
    </div>
  `;
  document.querySelectorAll(".ff-footer__columns, .luxe-dark-footer__grid").forEach((columns) => {
    columns.innerHTML = html;
  });
  document.querySelectorAll(".ff-footer__copyright, .luxe-dark-footer__legal").forEach((node) => {
    node.textContent = "© 2026 Luxe Outlet. All rights reserved.";
  });
};

const normalizeContactPage = () => {
  if (!window.location.pathname.includes("/pages/contact")) return;
  const main = document.querySelector("#MainContent .shopify-section");
  if (!main) return;
  main.innerHTML = `
    <section class="ff-page">
      <h1>Contact Us</h1>
      <div class="rte ff-policy-copy">
        <p>Monday to Saturday, 10:30am to 7:00pm</p>
        <p>Support: <a href="mailto:info@luxe-outlet.com">info@luxe-outlet.com</a></p>
      <p>Pocket 8, Block B, Rohini Sector 15, New Delhi - 110089</p>
        <p>Orders are processed by Luxe Outlet after payment verification or cash-on-delivery confirmation. Delivery timelines depend on the product and service level shown on the product page.</p>
        <p>For the fastest support, include your order number, the product link, and a short description of the issue in your email.</p>
      </div>
    </section>
  `;
};

const ensureBusinessSchema = () => {
  if (!document.head) return;

  if (!document.getElementById("ff-organization-schema")) {
    const org = document.createElement("script");
    org.type = "application/ld+json";
    org.id = "ff-organization-schema";
    org.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Luxe Outlet",
      legalName: "Metacircles Technologies Private Limited",
      url: "https://luxe-outlet.com",
      email: "info@luxe-outlet.com",
      identifier: "GSTIN 06AARCM2647M1ZV",
      sameAs: ["https://www.instagram.com/luxeoutlet"],
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: "info@luxe-outlet.com",
          availableLanguage: ["en", "hi"]
        }
      ]
    });
    document.head.appendChild(org);
  }

  if (!document.getElementById("ff-website-schema")) {
    const site = document.createElement("script");
    site.type = "application/ld+json";
    site.id = "ff-website-schema";
    site.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Luxe Outlet",
      url: "https://luxe-outlet.com",
      publisher: {
        "@type": "Organization",
        name: "Luxe Outlet"
      },
      potentialAction: {
        "@type": "SearchAction",
        target: "https://luxe-outlet.com/search?type=product&q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    });
    document.head.appendChild(site);
  }
};

const initProductForm = (form) => {
  const sectionId = form.getAttribute("data-section-id");
  const variantsScript = document.querySelector(`[data-product-variants="${sectionId}"]`);
  if (!variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch {
    return;
  }

  const sizeIndex = Number(form.getAttribute("data-size-index"));
  const shippingIndex = Number(form.getAttribute("data-shipping-index"));
  const idInput = form.querySelector("[data-variant-id]");
  const sizeSelect = form.querySelector("[data-size-select]");
  const shippingProperty = form.querySelector("[data-shipping-property]");
  const priceEl = form.querySelector("[data-product-price]");
  const skuEl = document.querySelector("[data-style-code]");
  const submit = form.querySelector('button[type="submit"]');
  const shippingMessage = form.querySelector("[data-shipping-message]");
  const qtyInput = form.querySelector("[data-qty-input]");
  const qtyMinus = form.querySelector("[data-qty-minus]");
  const qtyPlus = form.querySelector("[data-qty-plus]");
  const shippingTabs = Array.from(form.querySelectorAll("[data-shipping-method]"));
  const detailQuantity = document.querySelector("[data-detail-quantity]");
  let selectedShipping = shippingTabs.find((tab) => tab.classList.contains("is-active"))?.dataset.shippingMethod || "3-5 Days";

  if (sizeSelect) {
    Array.from(sizeSelect.options).forEach((option) => {
      option.dataset.rawValue = option.value;
      option.textContent = displaySizeLabel(option.value || option.textContent);
    });
  }

  const shippingForVariant = (variant) => shippingIndex < 0 ? "" : variant.options[shippingIndex];
  const sizeForVariant = (variant) => sizeIndex < 0 ? "One Size" : cleanSizeLabel(variant.options[sizeIndex]);
  const selectedSize = () => cleanSizeLabel(sizeSelect?.value || sizeSelect?.selectedOptions?.[0]?.dataset.rawValue || sizeSelect?.selectedOptions?.[0]?.textContent || "");

  const variantsForShipping = (shipping) => {
    const matching = variants.filter((variant) => shippingIndex < 0 || shippingMatches(shippingForVariant(variant), shipping));
    return matching.length ? matching : variants;
  };

  const rebuildSizes = (preferredSize = selectedSize()) => {
    if (!sizeSelect) return;
    const seen = new Set();
    const options = variantsForShipping(selectedShipping);
    sizeSelect.innerHTML = "";
    options.forEach((variant) => {
      const rawSize = sizeForVariant(variant);
      const key = normalize(rawSize);
      if (!rawSize || seen.has(key)) return;
      seen.add(key);
      const option = document.createElement("option");
      option.value = rawSize;
      option.dataset.rawValue = rawSize;
      option.textContent = displaySizeLabel(rawSize);
      sizeSelect.append(option);
    });
    const preferred = Array.from(sizeSelect.options).find((option) => normalize(option.value) === normalize(preferredSize));
    if (preferred) {
      sizeSelect.value = preferred.value;
    } else if (sizeSelect.options[0]) {
      sizeSelect.value = sizeSelect.options[0].value;
    }
  };

  const findVariant = () => {
    const size = selectedSize();
    return variants.find((variant) => {
      const variantSize = sizeForVariant(variant);
      const sizeOk = sizeIndex < 0 || !size || normalize(variantSize) === normalize(size);
      const shippingOk = shippingIndex < 0 || shippingMatches(shippingForVariant(variant), selectedShipping);
      return sizeOk && shippingOk;
    }) || variants.find((variant) => {
      const variantSize = sizeForVariant(variant);
      const sizeOk = sizeIndex < 0 || !size || normalize(variantSize) === normalize(size);
      return sizeOk;
    }) || variants[0];
  };

  const update = () => {
    const variant = findVariant();
    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    const actualShipping = shippingForVariant(variant) || selectedShipping;
    selectedShipping = actualShipping;
    if (shippingProperty) shippingProperty.value = actualShipping;
    shippingTabs.forEach((item) => item.classList.toggle("is-active", shippingMatches(item.dataset.shippingMethod, actualShipping)));
    if (priceEl) {
      priceEl.innerHTML = `<strong>${money(variant.price)}</strong><s>${money(Math.round(variant.price * 1.5))}</s>`;
    }
    if (skuEl) skuEl.textContent = variant.sku || variant.id;
    if (shippingMessage) shippingMessage.textContent = `Ships in ${displayShippingLabel(actualShipping)}`;
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? "Add to bag" : "Sold out";
    }
  };

  shippingTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (tab.disabled) return;
      selectedShipping = tab.dataset.shippingMethod;
      shippingTabs.forEach((item) => item.classList.toggle("is-active", item === tab));
      rebuildSizes();
      update();
    });
  });

  if (sizeSelect) sizeSelect.addEventListener("change", update);
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener("click", () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      if (detailQuantity) detailQuantity.textContent = qtyInput.value;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener("click", () => {
      qtyInput.value = Number(qtyInput.value || 1) + 1;
      if (detailQuantity) detailQuantity.textContent = qtyInput.value;
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener("change", () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1));
      if (detailQuantity) detailQuantity.textContent = qtyInput.value;
    });
  }

  rebuildSizes();
  update();
};

document.addEventListener("DOMContentLoaded", () => {
  applyDefaultBestSellingSort();
  ensureBusinessSchema();
  ensureMobileSearch();
  normalizePdpMedia();
  enforceMobileLayoutFixes();
  setWishlistState();
  fixHomeRailScroll();
  initPopularityPlp();
  hydrateEmptyHomeProductRails();
  populatePdpRecommendations();
  document.querySelectorAll("[data-product-form]").forEach(initProductForm);
  initWheelPassthrough();
  initAjaxCart();
  initHomeProductCarousel();
  initHeroBannerCarousel();
  normalizeFooter();
  normalizeContactPage();
  enforceMobileLayoutFixes();
});

window.addEventListener("load", centerHomeProductCarousels);
window.addEventListener("load", fixHomeRailScroll);
window.addEventListener("load", initPopularityPlp);
window.addEventListener("load", hydrateEmptyHomeProductRails);
window.addEventListener("load", populatePdpRecommendations);
window.addEventListener("resize", centerHomeProductCarousels);
window.addEventListener("resize", fixHomeRailScroll);

document.addEventListener("click", (event) => {
  const pdpMediaViewMore = event.target.closest("[data-pdp-media-view-more]");
  if (pdpMediaViewMore) {
    event.preventDefault();
    const gallery = pdpMediaViewMore.closest("[data-pdp-media-gallery]");
    gallery?.querySelectorAll("[data-pdp-extra-media]").forEach((media) => {
      media.hidden = false;
      media.classList.remove("is-hidden");
      media.removeAttribute("data-pdp-extra-media");
    });
    pdpMediaViewMore.closest(".ff-pdp__media-more")?.remove();
    return;
  }

  const mobileSearchOpen = event.target.closest("[data-mobile-search-open]");
  if (mobileSearchOpen) {
    event.preventDefault();
    const header = mobileSearchOpen.closest(".ff-header__mobile");
    const input = header?.querySelector("[data-mobile-search-input]");
    header?.classList.add("is-searching");
    window.requestAnimationFrame(() => input?.focus());
    return;
  }

  const mobileSearchClose = event.target.closest("[data-mobile-search-close]");
  if (mobileSearchClose) {
    event.preventDefault();
    const header = mobileSearchClose.closest(".ff-header__mobile");
    const input = header?.querySelector("[data-mobile-search-input]");
    if (input) input.value = "";
    header?.classList.remove("is-searching");
    return;
  }

  const railArrow = event.target.closest(".ff-home .ff-rail-arrows button");
  if (railArrow) {
    const arrows = railArrow.closest(".ff-rail-arrows");
    const section = railArrow.closest(".ff-home-categories, .ff-home-rail");
    const rail = section?.querySelector("[data-ff-rail]");
    if (arrows && rail) {
      event.preventDefault();
      const buttons = Array.from(arrows.querySelectorAll("button"));
      const direction = buttons.indexOf(railArrow) === 0 ? -1 : 1;
      rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.82, 320), behavior: "smooth" });
    }
  }

  if (event.target.closest("[data-side-cart-close], [data-side-cart-overlay]")) {
    closeSideCart();
  }

  const openButton = event.target.closest("[data-menu-open]");
  const closeButton = event.target.closest("[data-menu-close]");
  const drawer = document.querySelector("[data-menu-drawer]");
  if (openButton && drawer) {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("ff-menu-open");
  }
  if (closeButton && drawer) {
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ff-menu-open");
  }

  const filterButton = event.target.closest("[data-filter-toggle]");
  if (filterButton) {
    if (window.matchMedia("(max-width: 749px)").matches) return;
    const panel = document.querySelector("[data-filter-panel]");
    const filterForm = document.querySelector("[data-filter-form]");
    if (panel) panel.classList.toggle("is-open");
    if (filterForm) filterForm.classList.toggle("is-open");
  }

  const viewMore = event.target.closest("[data-view-more]");
  if (viewMore) {
    event.preventDefault();
    if (viewMore.dataset.loading === "true") return;

    const grid = document.querySelector("[data-product-grid]");
    const pagination = viewMore.closest("[data-pagination]");
    if (!grid || !pagination) {
      window.location.href = viewMore.href;
      return;
    }

    viewMore.dataset.loading = "true";
    viewMore.textContent = "Loading...";

    fetch(viewMore.href, { headers: { Accept: "text/html" } })
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = doc.querySelector("[data-product-grid]");
        const nextPagination = doc.querySelector("[data-pagination]");
        if (!nextGrid) throw new Error("Missing next product grid");

        nextGrid.querySelectorAll(".ff-product-card").forEach((card) => {
          grid.appendChild(document.importNode(card, true));
        });

        if (nextPagination && nextPagination.querySelector("[data-view-more]")) {
          pagination.replaceWith(document.importNode(nextPagination, true));
        } else {
          pagination.remove();
        }

        if (typeof window.__luxePostAppendPlp === "function") {
          window.__luxePostAppendPlp();
        }
        setWishlistState();
      })
      .catch(() => {
        window.location.href = viewMore.href;
      });
  }

  const wishlistButton = event.target.closest("[data-wishlist-toggle]");
  if (wishlistButton) {
    event.preventDefault();
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem("ffWishlist") || "[]");
    } catch {
      saved = [];
    }
    const id = wishlistButton.getAttribute("data-product-id");
    saved = saved.includes(id) ? saved.filter((item) => item !== id) : [...saved, id];
    localStorage.setItem("ffWishlist", JSON.stringify(saved));
    setWishlistState();
  }

  const sideCartRemove = event.target.closest("[data-side-cart-remove]");
  if (sideCartRemove) {
    event.preventDefault();
    removeSideCartItem(sideCartRemove.getAttribute("data-side-cart-remove")).catch(() => {
      window.location.href = "/cart";
    });
  }
  const sideCartStep = event.target.closest("[data-side-cart-minus], [data-side-cart-plus]");
  if (sideCartStep) {
    event.preventDefault();
    const isPlus = sideCartStep.hasAttribute("data-side-cart-plus");
    const stepKey = sideCartStep.getAttribute(isPlus ? "data-side-cart-plus" : "data-side-cart-minus");
    const valEl = sideCartStep.parentElement.querySelector(".ff-side-cart__qty-val");
    const current = Number(valEl ? valEl.textContent : 0) || 0;
    updateSideCartQty(stepKey, current + (isPlus ? 1 : -1)).catch(() => {
      window.location.href = "/cart";
    });
  }

  const cartMinus = event.target.closest("[data-cart-qty-minus]");
  const cartPlus = event.target.closest("[data-cart-qty-plus]");
  if (cartMinus || cartPlus) {
    const control = event.target.closest(".ff-cart-qty");
    const input = control?.querySelector("[data-cart-qty-input]");
    if (!input) return;
    const next = Number(input.value || 0) + (cartPlus ? 1 : -1);
    input.value = Math.max(0, next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

let cartSubmitTimer;
document.addEventListener("submit", (event) => {
  const form = event.target.closest("[data-cart-form]");
  if (!form) return;
  const submitter = event.submitter;
  const isCheckout = submitter?.name === "checkout" || submitter?.hasAttribute("data-cart-discount-apply");
  const discountInput = form.querySelector("[data-cart-discount-input]");
  const discountCode = discountInput?.value?.trim();
  if (!isCheckout || !discountCode) return;

  event.preventDefault();
  const redirect = encodeURIComponent("/checkout");
  window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=${redirect}`;
});

document.addEventListener("change", (event) => {
  const filterInput = event.target.closest("[data-filter-input], [data-sort-select]");
  if (filterInput) {
    if (filterInput.closest("[data-plp-popularity]")) return;
    filterInput.form?.requestSubmit();
  }

  const cartQty = event.target.closest("[data-cart-qty-input]");
  if (!cartQty) return;
  const form = cartQty.closest("[data-cart-form]");
  if (form) {
    clearTimeout(cartSubmitTimer);
    cartSubmitTimer = setTimeout(() => form.requestSubmit(), 250);
  }
});
